import classNames from 'classnames';
import { Fragment } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { Button, Heading } from 'yoso';
import { BaseCard, BaseCardProps } from '~/components/Card';
import { T } from '~/components/I18n';
import { LandEvent, LandEventLand } from '~/components/Land/Event';
import landStyles from '~/components/Style/Land.module.scss';
import { format, formatCurrency } from '~/components/Util/number';
import styles from './LandCard.module.scss';
import statStyles from './LandStat.module.scss';

export type LandCardProps = Pick<LandEvent, 'week'> & LandEventLand & BaseCardProps;
export const LandCard = ({
  week,
  landId,
  landType,
  citizenNftLevel,
  winningRate,
  rewardAmount,
  isParticipated,
  zoneList,
}: LandCardProps) => (
  <BaseCard
    className={classNames(styles.root, styles[landType], landStyles[landType])}
    size="large">
    <div className={styles.header} />
    <div className={styles.body}>
      <div>
        <Heading level={5} className={styles.title}>
          <T name={`citizen_land_title_lv${citizenNftLevel}`} />
        </Heading>
        <div className={styles.description}>
          <span className={styles.descriptionLabel}>
            <T name="citizen_land_card_desc3" />
          </span>
          <dl className={styles.descriptionList}>
            {zoneList.map((each) => (
              <Fragment key={each.zoneId}>
                <dt>
                  <T name="citizen_land_zone" />
                  {each.zoneType.split('_')[1]}
                </dt>{' '}
                <dd>{format(each.rewardAmount)}</dd>
              </Fragment>
            ))}
          </dl>
        </div>
      </div>
      <div className={classNames(styles.stat, statStyles.root)}>
        <div className={statStyles.item}>
          <small className={statStyles.title}>
            <T name="citizen_land_card_desc4" />
          </small>
          <strong className={statStyles.value}>Lv{citizenNftLevel}</strong>
        </div>
        <hr className={statStyles.divider} />
        <div className={statStyles.item}>
          <small className={statStyles.title}>
            <T name="citizen_land_card_desc1" />
          </small>
          <strong className={statStyles.value}>{(winningRate * 100).toFixed(0)}%</strong>
        </div>
        <hr className={statStyles.divider} />
        <div className={statStyles.item}>
          <small className={statStyles.title}>
            <T name="citizen_land_card_desc2" />
          </small>
          <strong className={statStyles.value}>{formatCurrency(rewardAmount)}</strong>
        </div>
      </div>
    </div>
    <div className={styles.footer}>
      <Button<LinkProps>
        as={Link}
        to={`/land/event/${week}/land/${landId}`}
        className={styles.button}>
        <T
          name={
            isParticipated ? 'citizen_button_title_land_joined' : 'citizen_button_title_seedetails'
          }
        />
      </Button>
    </div>
  </BaseCard>
);
